/// <reference types="../filters/types" />

import $ from 'jquery';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/draggable';
import ko from 'knockout';
import _ from 'lodash';
import { dateHelper, errorHandler, featuresRepo } from '../common';
import '../common/withSilentUpdates';
import { ConditionGroupOperator, ConditionOperator, uiFiltersToAPIFilters } from '../filters';
import { authService } from '../login';
import { drawerMenu } from './drawerMenu';
import { reportDatesDialog } from './reportDatesDialog';
import { reportEditor } from './reportEditor';
import { reportFiltersEditorDialog } from './reportFiltersEditorDialog';
import { reportSharingDialog } from './reportSharingDialog';
import { reportTransitionDialog } from './reportTransitionDialog';
import { reportsRepo } from './reportsRepo';
import moment from 'moment';
import { uiHelper } from '../common';

/*
 gridUI

 This class represents the app UI.

 */

window.onpopstate = function (event) {
    //alert("location: " + document.location + ", state: " + JSON.stringify(event.state));
};

ko.components.register('report-grid-ui', {
    viewModel: reportGridUI,
    template: {
        element: 'report-grid-ui-template'
    }
});

function reportGridUI() {

    var self = this;

    let defaultReport = reportsRepo.getDefaultReportId();

    //Add a global reference to this instance of the component. HACK - This makes the drag/drop of the report drawer menu easier for now.
    window.reportGridUI = this;

    //Public functions
    self.bodyElement = ko.observable(null);
    self.isAdminUser = ko.observable(false);
    self.drawerMenu = ko.observable(new drawerMenu());
    self.draggedReportId = ko.observable(-1);
    self.draggedReportTitle = ko.observable("");
    self.draggedReportFolderName = ko.observable("");
    self.draggedReportIsReportOwner = ko.observable(false);
    self.dropTargetFolderName = ko.observable("");
    self.reportMenuItemIsDragging = ko.observable(false);
    self.moveReportDialogText = ko.computed(function () {
        return 'Move or copy "' + self.draggedReportTitle() + '" from "' + self.draggedReportFolderName() + '" to "' + self.dropTargetFolderName() + '"?';
    });
    self.removeReportDialogText = ko.computed(function () {
        return 'Remove "' + self.draggedReportTitle() + '" from "' + self.draggedReportFolderName() + '"?';
    });
    self.currentUsername = ko.observable("");
    self.showQueryDialog = ko.observable(false);
    self.queries = ko.observableArray([]);
    self.reportEditor = ko.observable(new reportEditor());
    self.showReportEditor = ko.observable(false);
    self.reportFiltersEditorDialog = ko.observable(new reportFiltersEditorDialog());
    self.showReportFiltersEditor = ko.observable(false);
    self.reportTransitionDialog = ko.observable(new reportTransitionDialog());
    self.showReportTransitionDialog = ko.observable(false);
    self.reportDatesDialog = ko.observable(new reportDatesDialog());
    self.showReportDatesDialog = ko.observable(false);
    self.reportSharingDialog = ko.observable(new reportSharingDialog());
    self.showReportSharingDialog = ko.observable(false);
    self.gridDataLoaded = ko.observable(false);
    self.drawerMenuIsOpen = ko.observable(false);
    self.reportTitle = ko.observable("Loading...");
    self.reportGridPageSize = ko.observable(750);
    self.editReportsFeatureEnabled = ko.observable(false);  //default to false until request returns with features
    self.selectedReport = ko.observable(
        {
            reportId: -1,
            isFavorite: false,
            dateRange: "Current-Week"
        });
    self.updatingReportFavoriteStatus = ko.observable(false);
    self.reportIsFavorite = ko.observable(self.selectedReport().isFavorite);
    self.isReportOwner = ko.computed(function () {

        if (_.isNullOrUndefined(self.selectedReport()) || _.isNullOrUndefined(self.selectedReport().reportOwners))
            return false;

        var owner = _.filter(self.selectedReport().reportOwners, function (o) { return _.lowerCase(o.username) === _.lowerCase(self.currentUsername()); });
        return owner && owner.length > 0;
    });

    self.isTrackmaxStandard = ko.computed(function () {

        if (self.selectedReport().reportId < 200)
            return true;
        else
            return false;

    });

    self.copyToClipboard = function (elementId) {
        uiHelper.copyToClipboard(elementId);
    };

    //Dates override
    self.dateRangeOverride = ko.observable(null).withSilentUpdates(); //date properties to use in place of the default date properties for this report
    self.overrideDateRange = ko.observable(false).withSilentUpdates();

    //Filters
    self.filters = ko.observableArray(null).withSilentUpdates();

    //Sort properties
    //The reportGridDrillIntoPropertiesUpdated callback references this object to update the URL hash.
    //The reportEditor save method references this object to save the current sort properties.
    self.defaultSortObject = ko.observable({ field: "", dir: "" }).withSilentUpdates();

    self.reportDateRangeDescription = ko.observable("");
    self.reportDateRangeString = ko.observable("");
    self.reportGridStateProps = ko.observable({});

    self.drillIntoBreadcrumbs = ko.observableArray([]);

    self.reportColumns = ko.observableArray([]);
    self.filteredColumns = ko.observableArray([]);
    self.allColumns = ko.observableArray([]);
    self.breakdownColumns = ko.observableArray([]); //cache the breakdown columns, they don't change.

    self.recordCount = ko.observable(0);
    self.reportTime = ko.observable(0);

    self.dataUrl = ko.observable("");

    self.showEmail = ko.observable(false);
    self.showMoveReportDialog = ko.observable(false);
    self.showRemoveReportDialog = ko.observable(false);
    self.newReportFolderName = ko.observable("");
    self.showAddNewReportFolderDialog = ko.observable(false);

    self.to = ko.observable("");
    self.subject = ko.observable("");
    self.body = ko.observable(self.dataUrl());

    /**
     * Loads the report by report id.
     * 
     * @param {unknown} resetUrl If true, reset all the drillInto and sort params.
     * @param {ConditionGroup?} filters The filters to apply to the report.
     */
    self.loadReport = async function (reportId, resetUrl, drillIntoFilters, sortObject, clearOverrides, filters) {
        if (self.bodyElement()) {
            await updateDefaultReportButton(reportId);
        } else {
            const subscription = self.bodyElement.subscribe(async () => {
                subscription.dispose();

                await updateDefaultReportButton(reportId);
            });
        }

        //Default to true
        resetUrl = _.defaultIfNullOrUndefined(resetUrl, true);

        //Clear the report overriden properties
        if (_.isNullOrUndefined(clearOverrides) || clearOverrides === true) {
            resetOverrides();
        }

        //Reset this flag to show a grid request has not completed yet
        self.gridDataLoaded(false);

        //Go get the full report and the breakdown columns
        $.when(
            reportsRepo.getReportFull(reportId),
            reportsRepo.getBreakdownColumns(),
            reportsRepo.getAllInsightColumns()).then(
                function (report, breakdownColsResult, allColsResult) {
                    if (!report) return unauthorized();

                    if (!filters) {
                        filters = report.filters.direct;
                    }

                    self.filters.silentUpdate(filters);

                    self.selectedReport(report);

                    self.reportIsFavorite(report.isFavorite);

                    self.breakdownColumns(breakdownColsResult);

                    self.allColumns(ko.mapping.fromJS(allColsResult)());

                    updateReportGridStateProps(resetUrl, drillIntoFilters, null, sortObject);
                },
                function (xhr, status, error) {
                    errorHandler.processResponse(xhr);
                }
            );
    }

    var getDrillIntoFiltersFromUrl = function () {
        var results = [];
        var queryObj = _.getUrlQueryObject();

        if (!queryObj.drill)
            return results;

        var drillIntoFilters = JSON.parse(queryObj.drill);

        //Add the drillInto filters
        _.forEach(drillIntoFilters, function (f) {

            //Make sure the filter has a field value.
            //Don't add filters that were used to transition to this report from a previous one.
            if (f.field && _.defaultIfNullOrUndefined(f.transitionFilter, false) === false) {

                var multipleValues = f.values && f.values.length > 1;

                _.forEach(f.values, function (v) {

                    var filter = {
                        columnId: null,
                        column: null,
                        fieldName: f.field,
                        operator: "eq",
                        value: v,
                        type: multipleValues ? "or" : "and"
                    }

                    results.push(filter);
                })
            }
        })

        //Remove duplicate filters
        results = _.uniqBy(results, function (f) { return f.fieldName + '|||' + f.value; });

        return results;
    }

    self.addReportToFavorites = function () {

        self.updatingReportFavoriteStatus(true);

        var reportId = self.selectedReport().reportId;
        $.when(
            reportsRepo.addReportToFavorites(reportId)).then(
                function (result) {
                    self.updatingReportFavoriteStatus(false);
                    self.selectedReport().isFavorite = true;
                    self.reportIsFavorite(true);
                    createDrawerMenu();
                },
                function (xhr, status, error) {
                    self.updatingReportFavoriteStatus(false);
                    errorHandler.processResponse(xhr);
                }
            );
    }

    self.removeReportFromFavorites = function () {

        self.updatingReportFavoriteStatus(true);

        var reportId = self.selectedReport().reportId;
        $.when(
            reportsRepo.removeReportFromFavorites(reportId)).then(
                function (result) {
                    self.updatingReportFavoriteStatus(false);
                    self.selectedReport().isFavorite = false;
                    self.reportIsFavorite(false);
                    createDrawerMenu();
                },
                function (xhr, status, error) {
                    self.updatingReportFavoriteStatus(false);
                    errorHandler.processResponse(xhr);
                }
            );
    }

    //Callback function the report grid will call to update properties for the url query.
    self.reportGridDrillIntoPropertiesUpdated = function (props) {

        //Check to see if the grid passed back valid props.
        if (!_.isNullOrUndefined(props)) {

            //Create a new query object based on the properties passed back from the grid.
            var queryObj = {};
            queryObj.drill = JSON.stringify(props.drillIntoFilters);
            queryObj.groupby = props.groupByFieldName || "";
            queryObj.breakdown = props.breakdownFieldName || "";

            //Get the stored sort properties
            queryObj.sort = self.defaultSortObject().field;
            queryObj.sortdir = self.defaultSortObject().dir;

            //Get the report id
            queryObj.reportid = self.selectedReport().reportId || "";

            //Parse the queryObj to a querystring
            var query = _.getUrlQueryFromObject(queryObj);

            //Update the url...
            //If we use replaceState instead of pushState, the user won't be able to use the back button.
            //GFW: I chose to use replaceState because reloading the grid after using pushState here would
            //require listening for the statechange or popstate events.  Those calls are not coming back consistently in a 
            //way that make it a viable option. The events fire multiple times, which makes using them difficult at best.
            //So, I am just taking away the ability to use the back button.
            history.replaceState(queryObj, $(document).attr("title"), query);

            //Update the drillIntoBreadcrumbs based on the current drillIntoFilters passed back from the grid.
            self.drillIntoBreadcrumbs([{ field: "Root", values: [self.selectedReport().title], isFilter: false }]);
            _.forEach(props.drillIntoFilters, function (filter) {
                filter.isFilter = true;

                //Don't add the filter to the list of breadcrumbs if this was added in the transition dialog.
                if (_.defaultIfNullOrUndefined(filter.transitionFilter, false) === false) {
                    self.drillIntoBreadcrumbs.push(filter);
                }
            });

            //Add a breadcrumb to the end of the trail that displays the current breakdown location
            if (queryObj.breakdown.length > 0)
                self.drillIntoBreadcrumbs.push({ field: queryObj.breakdown, values: [queryObj.breakdown], isFilter: false });
        }
    }

    //Callback function the report grid will call to update sort properties for the url query.
    self.reportGridSortPropertiesUpdated = function (props) {

        if (!_.isNullOrUndefined(props)) {

            //Store the sort properties.
            //The reportGridDrillIntoPropertiesUpdated callback references this object to update the URL hash.
            //The reportEditor save method references this object to save the current sort properties.
            var sortObject = {};
            sortObject.field = props.sortField || "";
            sortObject.dir = props.sortDirection || "";
            self.defaultSortObject(sortObject);
            self.queries([]);
        }
    }

    self.getSelectedReportColumns = function () {
        return self.selectedReport().columns;
    }

    //Callback function the report grid columnResize happens.
    self.reportGridColumnResized = function (props) {

        //Update the column width using the api
        if (!_.isNullOrUndefined(props) && !_.isNullOrUndefined(props.id) && !_.isNullOrUndefined(props.newWidth)) {

            reportsRepo.updateColumnWidth(props.id, props.newWidth).then(
                function (result) {
                    var col = _.find(self.selectedReport().columns, function (c) { return c.id == props.id; });
                    col.width = props.newWidth;
                },
                function (xhr) {
                    //errorHandler.processResponse(xhr);
                }
            );
        }
    }

    //Called when a drillInto breadcrumb is clicked.
    self.drillIntoBreadcrumbClick = function (clickedBreadcrumbIndex) {

        var breadcrumbCount = self.drillIntoBreadcrumbs().length;
        if (clickedBreadcrumbIndex > 0 && breadcrumbCount - clickedBreadcrumbIndex === 1)
            return;

        var resetUrl = false; //We don't want to reset all url params.    
        updateReportGridStateProps(resetUrl, null, clickedBreadcrumbIndex);
    }

    //Called when the grid request is completed (with errors or not)
    self.reportGridRequestCompleted = function (xhr, status, url) {

        //Data is loaded
        self.gridDataLoaded(true);

        //Handle any authorization errors
        if (xhr.status === 403) return unauthorized();
        else authService.handleApiResult(xhr);

        //Handle 500 errors
        errorHandler.processResponse(xhr);

        var reportDates = [];
        var dateRange = "";

        if (xhr && xhr.responseJSON) {
            self.recordCount(xhr.responseJSON['resultCount']);
            self.reportTime(parseFloat(xhr.responseJSON['resultMilliseconds'] / 1000.00).toFixed(2));

            const allColumns = self.allColumns();

            //Update the filters list
            var filteredColumns = xhr.responseJSON.filteredColumns || [];
            for (const filter of filteredColumns) {
                filter.caption = allColumns.find(column => column.columnId() === filter.key).caption();

                filter.formattedString = filterToString(filter.value, allColumns);
            }
            self.filteredColumns(ko.mapping.fromJS(filteredColumns));

            reportDates = xhr.responseJSON["reportDates"];
            dateRange = xhr.responseJSON["dateRangeFriendly"];

            if (xhr.responseJSON.queries) {
                const queries = xhr.responseJSON["queries"] || [];
                if (queries.length > 0) {
                    queries.map(x => self.queries.push(x));
                }
            }
        }

        //Update date display
        updateEditorDateRangeValues(dateRange, reportDates);

        self.dataUrl(url);
    }

    //Called when the report grid transition is initiated
    self.reportGridTransitionClick = function (filters) {

        self.showReportTransitionDialog(true);

        //If filters are undefined, the user clicked the Jump button outside of the grid.
        //So we need to get the filters from the url instead of having them passed to us.
        if (_.isNullOrUndefined(filters)) {
            filters = getDrillIntoFiltersFromUrl();
        }

        //Create the report transition dialog
        self.reportTransitionDialog(
            new reportTransitionDialog({
                onLoadFailedCallback: null,
                transitionToReportCallback: self.transitionToReport,
                getReportsDataPromise: reportsRepo.getAllReports,
                getReportsDataPromiseArgs: [],
                getReportColumnsDataPromise: reportsRepo.getAllInsightColumns,
                getReportColumnsDataPromiseArgs: [],
                getReportFiltersDataPromise: function () {
                    var deferred = $.Deferred();

                    $.when(
                        reportsRepo.getAllInsightColumns(),
                        reportsRepo.getReportFilters(self.selectedReport().reportId)).then(
                            function (columns, savedFilters) {

                                //Loop through filters and add columns that are missing.
                                _.forEach(filters, function (f) {

                                    if (!f.columnId) {

                                        var column = _.find(columns, function (c) {
                                            return c.field === f.fieldName;
                                        });

                                        if (column) {
                                            f.column = column;
                                            f.columnId = column.columnId;
                                        }
                                    }

                                    f.sourceType = "Report";
                                });

                                const apiFilters = uiFiltersToAPIFilters(filters);

                                var filtersToAdd = self.filters() ?? savedFilters.direct;
                                _.forEach(filtersToAdd, function (fil) {
                                    filters.push(ko.toJS(fil));
                                });

                                const groups = [apiFilters, filtersToAdd].filter(Boolean);

                                const allFilters = groups.length > 1
                                    ? { conditions: [], groups, operator: ConditionGroupOperator.And }
                                    : groups[0];

                                deferred.resolve({ direct: allFilters });
                            },
                            function (xhr) {
                                deferred.reject(xhr);
                            }
                        );

                    return deferred.promise();
                },
                getReportFiltersDataPromiseArgs: []
            }));
    }

    //This is a callback function that our reportTransitionDialog will call when the user clicks the "Jump to Report" button.
    self.transitionToReport = function (reportId, filters) {

        //Add the filters overrid
        self.filters.silentUpdate(filters);

        var dateRange = self.dateRangeOverride() !== null ? self.dateRangeOverride() : self.selectedReport().dateRange;
        self.dateRangeOverride.silentUpdate(dateRange);
        self.overrideDateRange.silentUpdate(true);

        self.showReportTransitionDialog(false);
        self.loadReport(reportId, true, null, self.defaultSortObject(), false, filters);
    }

    self.reportTransitionDialogClosed = function () {
        self.showReportTransitionDialog(false);
    }

    //Watch for a change in the selected report
    self.selectedReport.subscribe(function (report) {
        self.reportTitle(report.title);
        self.reportColumns(report.columns);
    });

    self.toggleQueryDialog = function () {
        self.showQueryDialog(true);
    }

    self.queryDialogClosed = function () {
        self.showQueryDialog(false);
    }

    self.toggleDrawerMenu = function () {
        const menu = document.getElementById('drawer-menu');

        const openClass = 'open';

        const resize = new Event('resize');

        const [transitionDuration] = /\d+/.exec(getComputedStyle(menu).getPropertyValue('--drawer-transition-milliseconds'));

        const classes = menu.classList;

        const opening = !classes.contains(openClass);

        classes.toggle(openClass, opening);

        self.drawerMenuIsOpen(opening);

        setTimeout(() => window.dispatchEvent(resize), transitionDuration);
    }

    self.toggleReportDatesDialog = function () {

        self.showReportDatesDialog(!self.showReportDatesDialog());

        if (self.showReportDatesDialog()) {

            //Create the dialog
            self.reportDatesDialog(
                new reportDatesDialog({
                    onApplyCallback: function (dateRange) {
                        self.showReportDatesDialog(false);
                        self.dateRangeOverride.silentUpdate(dateRange);
                        self.overrideDateRange.silentUpdate(true);
                        self.loadReport(self.selectedReport().reportId, false, null, self.defaultSortObject(), false, self.filters());
                    },
                    onCancelCallback: function () {
                        self.showReportDatesDialog(false);
                    },
                    getDateRangeDataPromise: function () {

                        var deferred = $.Deferred();

                        if (self.overrideDateRange()) {

                            var props = ko.mapping.toJS(self.dateRangeOverride());

                            deferred.resolve(props);
                        }
                        else {
                            reportsRepo.getReport(self.selectedReport().reportId).then(
                                function (report) {
                                    deferred.resolve(report.dateRange);
                                },
                                function (xhr) {
                                    errorHandler.processResponse(xhr);
                                    deferred.reject(xhr);
                                });
                        }

                        return deferred.promise();
                    }
                }));
        }
    }

    self.toggleReportSharingDialog = function () {

        self.showReportSharingDialog(!self.showReportSharingDialog());

        if (self.showReportSharingDialog()) {

            //Create the dialog
            self.reportSharingDialog(
                new reportSharingDialog({
                    reportId: self.selectedReport().reportId,
                    onSaveCompleted: self.reportSharingDialogSaveCompleted,
                    onCancel: self.toggleReportSharingDialog,
                    getAllReportShareObjectsDataPromise: function () {

                        var deferred = $.Deferred();

                        reportsRepo.getAllReportShareObjects().then(
                            function (results) {
                                deferred.resolve(results);
                            },
                            function (xhr) {
                                errorHandler.processResponse(xhr);
                                deferred.reject(xhr);
                            });

                        return deferred.promise();
                    },
                    getReportShareDataPromise: function (reportId) {

                        var deferred = $.Deferred();

                        reportsRepo.getReportShareData(reportId).then(
                            function (shareData) {
                                deferred.resolve(shareData);
                            },
                            function (xhr) {
                                errorHandler.processResponse(xhr);
                                deferred.reject(xhr);
                            });

                        return deferred.promise();
                    },
                    saveReportShareDataPromise: function (shareData) {

                        var deferred = $.Deferred();

                        reportsRepo.saveReportShareData(shareData).then(
                            function (shareData) {
                                deferred.resolve(shareData);
                            },
                            function (xhr) {
                                errorHandler.processResponse(xhr);
                                deferred.reject(xhr);
                            });

                        return deferred.promise();
                    }
                }));
        }
    }

    self.toggleReportEditor = function () {

        self.showReportEditor(!self.showReportEditor());

        if (self.showReportEditor()) {

            //Create the columns editor
            self.reportEditor(
                new reportEditor({
                    reportId: self.selectedReport().reportId,
                    isReportOwner: self.isReportOwner(),
                    onSaveCompleted: self.reportEditorSaveCompleted,
                    onDeleteCompleted: self.reportEditorDeleteCompleted,
                    onCancel: self.toggleReportEditor,
                    getReportDataPromise: function (reportId) {

                        var deferred = $.Deferred();

                        reportsRepo.getReportFull(reportId).then(
                            function (report) {

                                if (self.overrideDateRange() && !_.isNullOrUndefined(self.dateRangeOverride())) {
                                    report.dateRange = self.dateRangeOverride();
                                }

                                deferred.resolve(report);
                            },
                            function (xhr) {
                                errorHandler.processResponse(xhr);
                                deferred.reject(xhr);
                            });

                        return deferred.promise();
                    },
                    getAllColumnsDataPromise: reportsRepo.getAllInsightColumns,
                    deleteReportDataPromise: reportsRepo.deleteReport,
                    saveReportAsNewDataPromise: reportsRepo.saveReportAsNew,
                    updateReportFullDataPromise: async function (report, columns) {
                        //Send the sort column properties to update function
                        var sortField = !_.isNullOrUndefined(self.defaultSortObject()) && !_.isNullOrUndefined(self.defaultSortObject().field) ? self.defaultSortObject().field : "";
                        var sortDescending = !_.isNullOrUndefined(self.defaultSortObject()) && !_.isNullOrUndefined(self.defaultSortObject().dir) ? self.defaultSortObject().dir.toLowerCase() === "desc" ? true : false : false;
                        report.sortColumn = sortDescending ? sortField + " Desc" : sortField + " Asc";

                        const response = await reportsRepo.updateReportFull(report, columns);

                        errorHandler.processResponse(response);

                        return response;
                    },
                    saveReportFiltersDataPromise: async function (reportId) {
                        //Determine if the user set any filters that should override what's stored on the server.
                        //If so, get the filters that should override.
                        var filters = self.filters() ? ko.mapping.toJS(self.filters()) : undefined;

                        const response = await reportsRepo.saveReportFilters(reportId, filters);

                        errorHandler.processResponse(response);

                        return response;
                    }
                }));
        }
    }

    self.toggleReportFiltersEditor = function () {

        self.showReportFiltersEditor(!self.showReportFiltersEditor());

        if (self.showReportFiltersEditor()) {

            //Create the columns editor
            self.reportFiltersEditorDialog(
                new reportFiltersEditorDialog({
                    onApplyCallback: function (uiFilters) {
                        const apiFilters = uiFiltersToAPIFilters(uiFilters);

                        self.showReportFiltersEditor(false);
                        self.filters(apiFilters);
                    },
                    onCancelCallback: function () {
                        self.showReportFiltersEditor(false);
                    },
                    getReportFiltersDataPromise: function () {

                        var deferred = $.Deferred();

                        if (self.filters()) {

                            var filters = { direct: ko.mapping.toJS(self.filters()) };

                            deferred.resolve(filters);
                        }
                        else {
                            reportsRepo.getReportFilters(self.selectedReport().reportId).then(
                                function (result) {
                                    deferred.resolve(result);
                                },
                                function (xhr) {
                                    errorHandler.processResponse(xhr);
                                    deferred.reject(xhr);
                                });
                        }

                        return deferred.promise();
                    },
                    getReportColumnsDataPromise: function () {

                        var deferred = $.Deferred();

                        reportsRepo.getAllInsightColumns().then(
                            function (result) {
                                deferred.resolve(result);
                            },
                            function (xhr) {
                                errorHandler.processResponse(xhr);
                                deferred.reject(xhr);
                            });

                        return deferred.promise();
                    },
                    getListOfValuesColumnsDataPromise: function () {

                        var deferred = $.Deferred();

                        reportsRepo.getListOfValuesColumns().then(
                            function (result) {
                                deferred.resolve(result);
                            },
                            function (xhr) {
                                errorHandler.processResponse(xhr);
                                deferred.reject(xhr);
                            });

                        return deferred.promise();
                    }
                }));
        }
    }

    self.toggleEmail = function () {
        self.showEmail(!self.showEmail());
    }

    self.refreshCurrentReport = function () {
        var reportId = self.selectedReport().reportId;
        self.loadReport(reportId, true);
    }

    self.reportEditorSaveCompleted = function (reportId) {
        self.toggleReportEditor();
        createDrawerMenu();
        self.loadReport(_.defaultIfNullOrUndefined(reportId, self.selectedReport().reportId));
    }

    self.reportEditorDeleteCompleted = function (reportId) {
        self.toggleReportEditor();
        createDrawerMenu();
        loadDefaultReport();
    }

    self.reportDatesDialogClosed = function () {
        self.showReportDatesDialog(false);
    }

    self.reportSharingDialogSaveCompleted = function () {
        self.toggleReportSharingDialog();
    }

    self.reportSharingDialogClosed = function () {
        self.showReportSharingDialog(false);
    }

    self.reportFiltersEditorClosed = function () {
        self.showReportFiltersEditor(false);
    }

    self.reportEditorClosed = function () {
        self.showReportEditor(false);
    }

    self.emailClosed = function () {
        self.showEmail(false);
    }

    self.moveFolderClosed = function () {
        self.showMoveFolder(false);
    }

    self.addNewReportFolderDialogClosed = function () {
        self.showAddNewReportFolderDialog(false);
    }

    self.exportReportToExcel = function () {

        var postData = {};
        if (!_.isNullOrUndefined(self.overrideDateRange()) && self.overrideDateRange() === true) {
            postData.dateRangeOverride = self.dateRangeOverride();
            postData.overrideDateRange = true;
        }
        if (self.filters()) {
            postData.reportFiltersOverride = self.filters();
            postData.overrideReportFilters = true;
        }

        postData.sortField = self.defaultSortObject().field;
        postData.sortDirection = self.defaultSortObject().dir;

        //If the current URL contains a drill parameter we need to pass that along so the 
        //Excel file can show the breakdowns
        var queryObj = _.getUrlQueryObject();

        postData.exportDrillFilterString = queryObj.drill ? queryObj.drill : null;
        postData.exportDrillFilters = queryObj.drill ? JSON.parse(queryObj.drill) : null;

        reportsRepo.exportToExcel(self.selectedReport().reportId, postData, queryObj.breakdown).then(
            function (result) {
                //Do nothing
            },
            function (xhr) {
                errorHandler.processResponse(xhr);
            }
        );
    }

    self.emailReport = function () {
        if (self.to() != "") {
            document.getElementById("btnEmail").disabled = true;
            document.getElementById("imgSendEmail").style.display = 'block';
            reportsRepo.emailReport(self.to(), '', '<html><table style=\"color:black;font-size:11pt;font-family:Tahoma;\"><tr><td>' + self.subject().replace(/\r?\n/g, '<br />') + '</td></tr></table> <br/><br/> <table width="100%" border="0" cellspacing="0" cellpadding="0">  <tr>    <td>      <table border="0" cellspacing="0" cellpadding="0">        <tr>          <td align="center" style="-webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px;" bgcolor="#e9703e"><a href="' + window.location.href + '" target="_blank" style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; color: #ffffff; text-decoration: none; text-decoration: none; -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px; padding: 12px 18px; border: 1px solid #e9703e; display: inline-block;">Click Here To View Report &rarr;</a></td>        </tr>      </table>    </td>  </tr></table></html>').then(
                function (result) {
                    document.getElementById("btnEmail").disabled = false;
                    document.getElementById("imgSendEmail").style.display = 'none';
                    self.emailClosed();
                },
                function (xhr) {
                    errorHandler.processResponse(xhr);
                }
            );
        }
    }

    self.copyUrl = function () {
        // Create a "hidden" input
        var aux = document.createElement("input");

        // Assign it the value of the specified element
        aux.setAttribute("value", window.location.href);

        // Append it to the body
        document.body.appendChild(aux);

        // Highlight its content
        aux.select();

        // Copy the highlighted text
        document.execCommand("copy");

        // Remove it from the body
        document.body.removeChild(aux);
    }

    //Private functions


    //Set the reportGridStateProps object that the grid will use to populate.
    //Get the props from the URL.
    //If resetUrl == true, reset the param values in the Url.
    //If indexToRemove is passed, remove the drillIntoFilter located at that index
    //and update the other properties accordingly.
    var updateReportGridStateProps = function (resetUrl, drillIntoFilters, clickedBreadcrumbIndex, sortObject) {

        //Get the parameters that were passed in the URL.
        var queryObj = _.getUrlQueryObject();
        var drillInto = resetUrl ? "" : queryObj.drill || "";
        drillIntoFilters = resetUrl ? drillIntoFilters || [] : !_.isNullOrUndefined(drillInto) && drillInto.length > 0 ? JSON.parse(drillInto) : [];
        var groupByFieldName = resetUrl ? "" : queryObj.groupby || "";
        var breakdownFieldName = resetUrl ? "" : queryObj.breakdown || "";

        sortObject = sortObject || {};
        var sortField = resetUrl ? sortObject.field || "" : queryObj.sort || "";
        var sortDirection = resetUrl ? sortObject.dir || "" : queryObj.sortdir || "";

        //Create default sort object
        var defaultSortObject = { field: sortField, dir: sortDirection };

        //Populate the stateProps object
        var stateProps = {};
        stateProps.drillIntoFilters = clickedBreadcrumbIndex === 0 ? [] : drillIntoFilters;
        stateProps.groupByFieldName = clickedBreadcrumbIndex === 0 ? "" : groupByFieldName;
        stateProps.breakdownFieldName = clickedBreadcrumbIndex === 0 ? "" : breakdownFieldName;
        stateProps.defaultSortObject = defaultSortObject;

        if (clickedBreadcrumbIndex > 0 && stateProps.drillIntoFilters.length > 0) {

            //Remove breadcrumbs that come after the clicked one.
            var breadcrumbIndexToRemove = clickedBreadcrumbIndex + 1;
            var removeCount = self.drillIntoBreadcrumbs().length - breadcrumbIndexToRemove;
            self.drillIntoBreadcrumbs.splice(breadcrumbIndexToRemove, removeCount);

            //Rebuild the drillIntoFilters array based on the remaining breadcrumbs

            //First, add back in any transition filters that are present
            var transitionFilters = _.filter(stateProps.drillIntoFilters, function (f) { return f.transitionFilter; });
            stateProps.drillIntoFilters = [];
            _.forEach(transitionFilters, function (f) {
                stateProps.drillIntoFilters.push(f);
            });

            //Then add in the remaining breadcrumb filters
            _.forEach(self.drillIntoBreadcrumbs(), function (b) {
                if (b.isFilter)
                    stateProps.drillIntoFilters.push(b);
            });

            //Set the new groupby and breakdown params taking effect once the filters are removed.
            var lastFilter = _.last(stateProps.drillIntoFilters);
            stateProps.groupByFieldName = lastFilter.field || "";
            stateProps.breakdownFieldName = "";
        }

        self.reportGridStateProps(stateProps);
    }

    var resetOverrides = function () {

        self.dateRangeOverride.silentUpdate(null); //date range to use in place of the default date range for this report
        self.filters.silentUpdate(null);
        self.overrideDateRange.silentUpdate(false);
        self.defaultSortObject.silentUpdate(null);
    }

    var updateEditorDateRangeValues = function (dateRange, reportDates) {

        var reportDateRange = _.nth(reportDates, 0) || {};
        var startDate = reportDateRange.startDate;
        var endDate = reportDateRange.endDate;

        var dateRangeString = startDate && endDate ? dateHelper.getShortDateString(startDate) + " to " + dateHelper.getShortDateString(endDate) : "Choose dates";
        var desc = dateRange ? dateRange : "";

        self.reportDateRangeString(dateRangeString);
        self.reportDateRangeDescription(desc);
    }

    var createDrawerMenu = function () {
        //Create the drawer menu
        self.drawerMenu(new drawerMenu(
            {
                onDragEndReportMenuItem: self.onDragEndReportMenuItem,
                onDragOverReportMenuItem: self.onDragOverReportMenuItem,
                onDragStartReportMenuItem: self.onDragStartReportMenuItem,
                onDropReportMenuItem: self.onDropReportMenuItem,
                onMenuItemClick: function (reportId) {
                    resetOverrides();
                    self.loadReport(reportId);
                },
                dataPromise: reportsRepo.getReportFolders
            }));
    }

    var loadDefaultReport = function () {

        //Get default report id, then load it
        defaultReport.then(
            function (reportId) {
                self.loadReport(reportId);
            },
            function (xhr) {
                errorHandler.processResponse(xhr);
            }
        );
    }

    self.moveReportDialogClosed = function () {
        self.showMoveReportDialog(false);
    }

    self.removeReportDialogClosed = function () {
        self.showRemoveReportDialog(false);
    }

    self.onDragOverReportMenuItem = function (event) {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
    }

    self.onDragStartReportMenuItem = function (event) {
        event.dataTransfer.effectAllowed = "move";

        self.draggedReportId(event.target.dataset.reportid);
        self.draggedReportTitle(event.target.textContent);
        self.draggedReportFolderName(event.target.dataset.foldername);
        self.draggedReportIsReportOwner(event.target.dataset.isreportowner === "true");
        self.reportMenuItemIsDragging(true);
    }

    self.onDragEndReportMenuItem = function (event) {
        self.reportMenuItemIsDragging(false);
    }

    self.onDropReportMenuItem = function (event) {
        if (self.draggedReportFolderName() !== event.target.dataset.foldername && self.draggedReportIsReportOwner()) {

            //Go ahead with prompting for move/copy
            self.dropTargetFolderName(event.target.dataset.foldername);

            if (event.target.dataset.foldername === "##remove##") {
                self.showRemoveReportDialog(true);
            }
            else if (event.target.dataset.foldername.toLowerCase() === "your reports") {
                //Don't allow a drop into the Your Misc Reports folder because it's a catch-all for uncategorized reports only
            }
            else {
                self.showMoveReportDialog(true);
            }
        }
    }

    self.moveReportToFolder = function () {
        reportsRepo.moveReportToFolder(self.draggedReportId(), self.draggedReportFolderName(), self.dropTargetFolderName()).then(
            function (result) {
                self.showMoveReportDialog(false);
                createDrawerMenu();
            },
            function (xhr) {
                errorHandler.processResponse(xhr);
            }
        );
    }

    self.removeReportFromFolder = function () {
        reportsRepo.removeReportFromFolder(self.draggedReportId(), self.draggedReportFolderName()).then(
            function (result) {
                self.showRemoveReportDialog(false);
                createDrawerMenu();
            },
            function (xhr) {
                errorHandler.processResponse(xhr);
            }
        );
    }

    self.copyReportToFolder = function () {
        reportsRepo.copyReportToFolder(self.draggedReportId(), self.dropTargetFolderName()).then(
            function (result) {
                self.showMoveReportDialog(false);
                createDrawerMenu();
            },
            function (xhr) {
                errorHandler.processResponse(xhr);
            }
        );
    }

    self.cancelMoveCopyReportToFolder = function () {
        self.showMoveReportDialog(false);
    }

    self.cancelRemoveReportFromFolder = function () {
        self.showRemoveReportDialog(false);
    }

    self.onAddNewReportFolderClick = function () {
        self.showAddNewReportFolderDialog(true);
    }

    self.cancelNewReportFolder = function () {
        self.showAddNewReportFolderDialog(false);
    }

    self.saveNewReportFolder = function () {
        reportsRepo.addNewReportFolder(self.selectedReport().reportId, self.newReportFolderName()).then(
            function (result) {
                self.newReportFolderName("");
                self.showAddNewReportFolderDialog(false);
                createDrawerMenu();
            },
            function (xhr) {
                errorHandler.processResponse(xhr);
            }
        );
    }

    const bodyElementSubscription = self.bodyElement.subscribe(async bodyElement => {
        const defaultButton = bodyElement.querySelector('.glyphicon-home');

        bodyElementSubscription.dispose();

        defaultButton.addEventListener('click', async () => {
            const { reportId } = self.selectedReport();

            if (await defaultReport !== reportId) {
                setDefaultReport(reportId);
            }
        });
    });

    var init = function () {

        //Get the url query object so we can work with the parameters that were passed in.
        var query = _.getUrlQueryObject();

        featuresRepo.getFeatures().then(
            function (result) {
                if (result && result.editReports)
                    self.editReportsFeatureEnabled(result.editReports);
            },
            function (err) {
            }
        );

        //Create the drawer menu
        createDrawerMenu();

        //Get current user's username
        self.currentUsername(authService.getLoginUser());

        self.isAdminUser(authService.isAdminUser());

        if (!_.isNullOrUndefined(query.reportid)) {

            //Load the report found in the URL. 
            //Do not reset the URL params for this request.
            var resetUrl = false;
            self.loadReport(_.toNumber(query.reportid), resetUrl);
        }
        else {
            loadDefaultReport();
        }
    }

    //Init the UI
    init();

    window.reportGridUI = self;

    /**
     * Updates the user's default report to the specified report.
     * 
     * @param {number} report The ID of the new default report.
     */
    function setDefaultReport(report) {
        defaultReport = Promise.resolve(report);

        updateDefaultReportButton(report);

        return reportsRepo.setDefaultReportId(report);
    }

    /**
     * Updates the state of the Default Report button to match the current report.
     * 
     * When the current report is the user's default report,
     * the button is highlighted and not clickable.
     * Otherwise, it is faded and clickable to make the current report the user's default.
     * 
     * @param {number} report The ID of the default report.
     */
    async function updateDefaultReportButton(report) {
        const defaultReportButton = self.bodyElement().querySelector('.glyphicon-home');

        const isDefault = await defaultReport === report;

        const label = isDefault ? 'Default Report' : 'Set as default report';

        defaultReportButton.classList.toggle('active', isDefault);

        defaultReportButton.setAttribute('aria-label', label);
        defaultReportButton.setAttribute('title', label);
    }
}

/**
 * Converts the specified filter condition to a human-readable string.
 * 
 * @param {Condition} condition The condition to convert.
 * @param {Column[]} columns The set of columns containing the column referenced by the condition.
 * 
 * @returns The human-readable description of the condition.
 * 
 * @throws The condition has an invalid operator.
 */
function conditionToString({ column, operator, value }, columns) {
    const caption = columns.find(col => col.columnId() === column).caption();
    const format = columns.find(col => col.columnId() === column).format();

    if (format !== null && format.toLowerCase() === "date") {
        value = moment(value).format("MM/DD/YYYY");
    }

    if (typeof value === 'string') {
        value = `"${value}"`;
    }

    switch (operator) {
        case ConditionOperator.Contains:
            return `${caption} contains ${value}`;
        case ConditionOperator.EndsWith:
            return `${caption} ends with ${value}`;
        case ConditionOperator.Equal:
            return `${caption} = ${value}`;
        case ConditionOperator.GreaterThan:
            return `${caption} > ${value}`;
        case ConditionOperator.GreaterThanOrEqual:
            return `${caption} >= ${value}`;
        case ConditionOperator.LessThan:
            return `${caption} < ${value}`;
        case ConditionOperator.LessThanOrEqual:
            return `${caption} <= ${value}`;
        case ConditionOperator.NotContains:
            return `${caption} does not contain "${value}"`;
        case ConditionOperator.NotEqual:
            return `${caption} does not equal ${value}`;
        case ConditionOperator.StartsWith:
            return `${caption} starts with "${value}"`;
    }

    throw new Error(`Cannot convert the condition to SQL because its operator (${operator}) is invalid.`);
}

/**
 * Converts the specified condition group operator to a string.
 * 
 * @param {ConditionGroupOperator} operator The operator to convert.
 * 
 * @returns The string representation of the group operator.
 */
function filterGroupOperatorToString(operator) {
    return ['AND', 'OR'][operator - 1];
}

/**
 * Converts the specified condition group to a human-readable string.
 * 
 * @param {ConditionGroup} group The group to convert.
 * @param {Column[]} columns The set of columns containing the column referenced by the group's descendant conditions.
 * 
 * @returns The human-readable description of the group.
 */
function filterToString({ conditions, groups, operator }, columns) {
    const operatorString = filterGroupOperatorToString(operator);

    let filterString = conditions.map(condition => conditionToString(condition, columns)).join(` ${operatorString} `);

    if (groups.length) {
        if (filterString.length) {
            filterString += ` ${operatorString} `;
        }

        const groupString = groups.map(group => filterToString(group, columns)).join(`) ${operatorString} (`);

        filterString += `(${groupString})`;
    }

    return filterString;
}

function unauthorized() {
    errorHandler.show('You are not authorized to view this report.');
}
